import { FC } from "react";
import { List } from "@mui/material";
import { appMenuRoutes } from "../../../../../../common/routesUtils";
import NavigationItem from "./NavigationItem";

interface Props {
	menuIsOpen: boolean;
	closeMenu: () => void;
}

/**
 * MenuNavigation is the side menu that allows users to navigate main sections of GreenRouter UI app.
 *
 * @param menuIsOpen  the flag that indicates if the menu is open or closed
 * @returns           the application side menu
 */

const MenuNavigation: FC<Props> = ({ menuIsOpen }) => {
	return (
		<List>
			{appMenuRoutes.map((i) => (
				<NavigationItem key={i.key} menuIsOpen={menuIsOpen} item={i} />
			))}
		</List>
	);
};

export default MenuNavigation;
